
















import { Vue, Component } from 'vue-property-decorator';
import { IsReadCurrentNotice, readCurrentNotice } from '../../services/NoticeService';
import appConfig from '../../appConfig';

@Component
export default class NoticeDialog extends Vue {
    private displayNotice = true;
    private readNotice = false;

    created(){
        this.displayNotice = !IsReadCurrentNotice();
    }

    mounted() {
        // お知らせのHTMLを取得しておく
        const htmlArea = this.$refs.htmlArea as Element;
        if (htmlArea) {
            fetch(appConfig.noticePageUrl)
                .then((res) => res.text())
                .then((text) => htmlArea.innerHTML = text);
        }
    }

    closeDialog() {
        this.displayNotice = false;
        if(this.readNotice)
            readCurrentNotice();
    }
}
